import React from "react";
import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

function GreyBox() {
  return (
    <Wrapper>
      <Typography
        variant="paragraph3"
        color="#282828"
        fontFamily="var(--mori)"
        fontWeight="600"
        style={{
          letterSpacing: "0px",
        }}
        fontSize={["16px", "16px", "16px"]}
      >
        There is no dearth of health information online. So, why did we choose
        to start this newsletter?
      </Typography>
      <ListWrapper>
        <List>
          <ListTypoGraphy variant="paragraph1">
            It can be tough to get straightforward and comprehensive answers to
            everyday health questions. Often, we end up more confused than
            informed, and that's the gap we wanted to bridge!
          </ListTypoGraphy>
        </List>

        <List>
          <ListTypoGraphy variant="paragraph1">
            With each newsletter, we're going to pick a relevant health topic
            and dive into it, providing readers with clarity and in-depth
            knowledge.
          </ListTypoGraphy>
        </List>

        <List>
          <ListTypoGraphy variant="paragraph1">
            Hopefully, along the way, we can play a key role in helping you make
            the right choices for your health.
          </ListTypoGraphy>
        </List>
      </ListWrapper>
    </Wrapper>
  );
}

export default GreyBox;

const Wrapper = styled(FlexDiv)`
  flex-direction: column;
  padding: 32px 24px 32px 24px;
  gap: 16px;
  border-radius: 20px;
  background-color: #f3f7ab;
  @media only screen and (max-width: 600px) {
    padding: 24px;
    border-radius: 16px;
  }
`;

const ListWrapper = styled.ul`
  margin: 0px 0px 0px 20px;
  padding: 0px;
`;
const List = styled.li`
  margin-top: 16px;
  &:nth-child(1) {
    margin-top: 0px;
  }
`;

const ListTypoGraphy = styled(Typography)`
  color: #293056;
  font-size: 14px;
  font-family: var(--mori);
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0px;
  @media only screen and (max-width: 600px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
